document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.focused-product-gallery').forEach(function(gallery) {
    let isDown = false;
    let startX;

    gallery.addEventListener('mousedown', function(e) {
      isDown = true;
      startX = e.pageX;
      gallery.style.cursor = 'grabbing';
      e.preventDefault();
    });

    document.addEventListener('mouseup', function() {
      isDown = false;
      gallery.style.cursor = 'grab';
    });

    document.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      const diff = e.pageX - startX;

      if (Math.abs(diff) > 60) {
        isDown = false;
        gallery.style.cursor = 'grab';

        if (diff < 0) {
          // Slider vers la droite → clic sur bouton Next
          const btnNext = gallery.querySelector('.swiper-button--next');
          if (btnNext) btnNext.click();
        } else {
          // Slider vers la gauche → clic sur bouton Prev
          const btnPrev = gallery.querySelector('.swiper-button--prev');
          if (btnPrev) btnPrev.click();
        }
      }
    });

    gallery.style.cursor = 'grab';
  });
});


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-slideshow').forEach(function(section) {
    let isDown = false;
    let startX;

    section.addEventListener('mousedown', function(e) {
      isDown = true;
      startX = e.pageX;
      section.style.cursor = 'grabbing';
      e.preventDefault();
    });

    document.addEventListener('mouseup', function() {
      isDown = false;
      section.style.cursor = 'grab';
    });

    document.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      const diff = e.pageX - startX;

      if (Math.abs(diff) > 60) {
        isDown = false;
        section.style.cursor = 'grab';

        if (diff < 0) {
          // Drag vers la gauche → slide suivante
          const btnNext = section.querySelector('.swiper-button--next');
          if (btnNext) btnNext.click();
        } else {
          // Drag vers la droite → slide précédente
          const btnPrev = section.querySelector('.swiper-button--prev');
          if (btnPrev) btnPrev.click();
        }
      }
    });

    section.style.cursor = 'grab';
  });
});